var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M11.238,1.85c-0.315-0.283-0.85-0.25-1.13,0.067L4.999,7.685L1.868,4.416 C1.573,4.107,1.046,4.094,0.736,4.391C0.419,4.695,0.408,5.202,0.712,5.521l3.73,3.898c0.15,0.157,0.361,0.248,0.578,0.248h0.016 h0.002C5.261,9.661,5.473,9.563,5.62,9.397l5.688-6.419c0.142-0.161,0.213-0.367,0.199-0.581C11.493,2.185,11.397,1.99,11.238,1.85z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckW);
export default __webpack_public_path__ + "static/media/checkW.d41a59e06be947d493d0a086745f39e2.svg";
export { ForwardRef as ReactComponent };